import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-outgoing',
  templateUrl: './stock-outgoing.component.html',
  styleUrls: ['./stock-outgoing.component.css']
})
export class StockOutgoingComponent implements OnInit {
    stockKeyno;

    public itemsListStockOutgoings: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockKeyno = this.stateService.getStateParams()['stock_keyno'];
    }

    private async loadStockOutgoings() {
        if (!!this.stockKeyno) {
            this.itemsListStockOutgoings = await this.datatask.Post(471, { stock_keyno: this.stockKeyno });
        }
    }

    private async init() {
        this.loadStockOutgoings();
    }

    ngOnInit() {
        this.init();
    }
}
